module.exports = __webpack_public_path__ + "media/images/grey-car-723ca74918a9e2ceb50fe79679431de8.png";